export const formatCurrency = (value, includeDecimal) => {
  if (typeof value !== "number") {
    value = 0;
  }

  const formattedVal = new Intl.NumberFormat("de-DE", {
    style: "currency",
    ...(!includeDecimal && { maximumFractionDigits: 0 }),
    currency: "EUR",
  }).format(value);

  return "€" + formattedVal.slice(0, formattedVal.length - 2);
};
